import React, {Component} from 'react'
import {Link} from 'react-router'

class Venue extends Component {
  render() {
    return (
      <tr>
        <th scope="row">{this.props.item}</th>
        <td>
          <Link to={'/venues/' + this.props.id}>
            <strong>{this.props.name}</strong>
          </Link>
        </td>
        <td>{this.props.postcode}</td>
      </tr>
    )
  }
}

export default Venue



/** WEBPACK FOOTER **
 ** ./src/components/venues/venue.js
 **/